// extracted by mini-css-extract-plugin
export default {"container":"FormSectionContainer_container__Ik2Lp","heading":"FormSectionContainer_heading__0gD03","content":"FormSectionContainer_content__MY-dG"};